export default () => {
    return {
        favouriteAccounts: [
            // {
            //     id: 123,
            //     name: 'Fun Company'
            // }
        ],
        theme: {
            colors: {
                primary: '#f89406',
                success: 'rgb(40,199,111)',
                danger: 'rgb(234,84,85)',
                warning: 'rgb(255,159,67)',
                dark: 'rgb(97,109,112)'
            },
            footerType: 'static', // options[String]  : static(default) / sticky / hidden
            hideScrollToTop: false, // options[Boolean] : true, false(default)
            mainLayoutType: 'horizontal', // options[String]  : vertical(default) / horizontal
            navbarColor: '#fff', // options[String]  : HEX color / rgb / rgba / Valid HTML Color name - (default: #fff)
            navbarType: 'static', // options[String]  : floating(default) / static / sticky / hidden
            routerTransition: 'slide-fade', // options[String]  : zoom-fade / slide-fade / fade-bottom / fade / zoom-out / none(default)
            rtl: false, // options[Boolean] : true, false(default)
            sidebarCollapsed: false, // options[Boolean] : true, false(default)
            theme: 'light' // options[String]  : "light"(default), "dark", "semi-dark"
        },
        posts: []
    }
}
